export interface ArticleMeta {
  slug: string;
  readingTime: number;
  updatedDate: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'usfans-spreadsheet-guide',
    readingTime: 8,
    updatedDate: '2026-08-21',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20fashion%20catalog%20flat%20lay%20with%20folded%20sweaters%20sneakers%20caps%20and%20accessories%20arranged%20in%20a%20tidy%20grid%20on%20a%20warm%20off%20white%20studio%20background%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=1200&height=630&seq=usfans-article-guide-01&orientation=landscape',
  },
  {
    slug: 'usfans-shipping-cost',
    readingTime: 6,
    updatedDate: '2026-08-20',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20kraft%20cardboard%20shipping%20boxes%20with%20a%20soft%20measuring%20tape%20and%20a%20small%20package%20on%20a%20clean%20light%20beige%20studio%20background%20soft%20shadows%20editorial%20ecommerce%20photography%20calm%20neutral%20tones%20high%20detail&width=1200&height=630&seq=usfans-article-shipping-01&orientation=landscape',
  },
  {
    slug: 'usfans-coupon',
    readingTime: 5,
    updatedDate: '2026-08-19',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20elegant%20gift%20card%20and%20a%20small%20paper%20voucher%20with%20a%20soft%20ribbon%20lying%20on%20a%20clean%20cream%20studio%20background%20gentle%20natural%20light%20minimal%20editorial%20product%20photography%20warm%20inviting%20tones%20high%20detail&width=1200&height=630&seq=usfans-article-coupon-01&orientation=landscape',
  },
  {
    slug: 'usfans-discount-code',
    readingTime: 5,
    updatedDate: '2026-08-18',
    image: 'https://readdy.ai/api/search-image?query=A%20few%20pastel%20sale%20price%20tags%20and%20a%20folded%20paper%20receipt%20scattered%20softly%20on%20a%20bright%20neutral%20studio%20surface%20subtle%20natural%20light%20minimal%20editorial%20still%20life%20photography%20clean%20aesthetic%20high%20detail&width=1200&height=630&seq=usfans-article-discount-01&orientation=landscape',
  },
  {
    slug: 'usfans-warehouse',
    readingTime: 6,
    updatedDate: '2026-08-17',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20light%20cardboard%20boxes%20on%20wooden%20shelving%20in%20a%20bright%20organized%20minimalist%20warehouse%20with%20soft%20natural%20window%20light%20clean%20neutral%20color%20palette%20editorial%20logistics%20photography%20high%20detail&width=1200&height=630&seq=usfans-article-warehouse-01&orientation=landscape',
  },
  {
    slug: 'usfans-legit',
    readingTime: 7,
    updatedDate: '2026-08-16',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20green%20shield%20icon%20beside%20a%20locked%20padlock%20resting%20on%20a%20clean%20white%20desk%20with%20a%20laptop%20softly%20blurred%20in%20the%20background%20gentle%20natural%20light%20minimal%20trust%20and%20security%20editorial%20photography%20high%20detail&width=1200&height=630&seq=usfans-article-legit-01&orientation=landscape',
  },
  {
    slug: 'usfans-review',
    readingTime: 7,
    updatedDate: '2026-08-15',
    image: 'https://readdy.ai/api/search-image?query=Five%20small%20golden%20stars%20resting%20beside%20a%20neatly%20folded%20denim%20jacket%20and%20sneakers%20on%20a%20clean%20beige%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20review%20photography%20warm%20neutral%20tones%20high%20detail&width=1200&height=630&seq=usfans-article-review-01&orientation=landscape',
  },
  {
    slug: 'usfans-creator-list',
    readingTime: 6,
    updatedDate: '2026-08-14',
    image: 'https://readdy.ai/api/search-image?query=An%20open%20notebook%20with%20a%20neat%20handwritten%20checklist%20and%20a%20pen%20on%20a%20bright%20minimal%20desk%20next%20to%20a%20small%20potted%20plant%20soft%20natural%20light%20editorial%20planning%20and%20organization%20photography%20clean%20neutral%20tones%20high%20detail&width=1200&height=630&seq=usfans-article-creator-01&orientation=landscape',
  },
  {
    slug: 'usfans-spreadsheet-search',
    readingTime: 6,
    updatedDate: '2026-08-13',
    image: 'https://readdy.ai/api/search-image?query=A%20large%20magnifying%20glass%20over%20a%20flat%20lay%20of%20folded%20clothing%20and%20accessories%20on%20a%20clean%20white%20studio%20background%20soft%20natural%20light%20minimal%20editorial%20search%20and%20discovery%20photography%20high%20detail&width=1200&height=630&seq=usfans-article-search-01&orientation=landscape',
  },
  {
    slug: 'usfans-safety-guide',
    readingTime: 7,
    updatedDate: '2026-08-12',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20green%20padlock%20and%20a%20check%20mark%20symbol%20on%20a%20clean%20light%20background%20with%20gentle%20natural%20light%20minimal%20editorial%20online%20safety%20and%20protection%20photography%20calm%20reassuring%20tones%20high%20detail&width=1200&height=630&seq=usfans-article-safety-01&orientation=landscape',
  },
  {
    slug: 'usfans-comparison-guide',
    readingTime: 6,
    updatedDate: '2026-08-11',
    image: 'https://readdy.ai/api/search-image?query=Two%20neat%20piles%20of%20folded%20clothing%20side%20by%20side%20in%20contrasting%20colors%20on%20a%20clean%20white%20studio%20surface%20soft%20natural%20light%20minimal%20editorial%20comparison%20and%20choice%20photography%20balanced%20composition%20high%20detail&width=1200&height=630&seq=usfans-article-comparison-01&orientation=landscape',
  },
];